module.exports = __webpack_public_path__ + "icon-arrow-down-blue-7b3fbedb8dfd2ea92089315757e36d27.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/svg/icon-arrow-down-blue.svg
// module id = 1898
// module chunks = 3 6